document.addEventListener('submit', async function(e) {
  const form = e.target;

  if (!form.action || !form.action.includes('/cart')) {
    return;
  }

  const cacttusInput = document.getElementById('cacttus-code');
  const cacttusMessage = document.getElementById('cacttus-message');
  const checkoutBtn = form.querySelector('[name="checkout"]') || document.querySelector('[name="checkout"]');
  
  const codeValue = cacttusInput ? cacttusInput.value.trim() : '';

  if (!codeValue) {
    return; 
  }

  e.preventDefault();
  e.stopPropagation();

  if (checkoutBtn) checkoutBtn.disabled = true;

  try {
    const response = await fetch('https://cacttus-shopify-bridge.vercel.app/api/verify', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ codeValue: codeValue }),
    });

    if (response.ok) {
      const data = await response.json();
      
      if (cacttusMessage) {
        cacttusMessage.classList.remove('hidden');
        cacttusMessage.style.color = '#2e7d32';
        cacttusMessage.innerText = `Descuento Cacttus aplicado. Redirigiendo al pago.`;
      }

      window.location.href = `/checkout`;

    } else {
      const errorData = await response.json();
      if (cacttusMessage) {
        cacttusMessage.classList.remove('hidden');
        cacttusMessage.style.color = '#c62828';
        cacttusMessage.innerText = `Error: ${errorData.message || 'Código inválido'}`;
      }

      if (checkoutBtn) checkoutBtn.disabled = false;
    }
  } catch (err) {
      if (cacttusMessage) {
        cacttusMessage.style.display = 'block';
        cacttusMessage.style.color = '#c62828';
        cacttusMessage.innerText = 'Error al intentar canjear el código. Intenta nuevamente.';
      }
      if (checkoutBtn) checkoutBtn.disabled = false;
  }
});
